import { useTranslation } from 'react-i18next';
import { PartyPopper } from 'lucide-react';

/**
 * Empty state component displayed when user has no tasks
 * Shows when both open processes and assignments are empty
 */
export function EmptyTasksState() {
  const { t } = useTranslation();

  return (
    <div className="flex h-64 items-center justify-center rounded-md border border-dashed border-positive-line">
      <div className="flex flex-col items-center gap-3 text-center">
        <span className="flex size-16 items-center justify-center rounded-full bg-positive-surface-strong text-positive-strong motion-safe:animate-celebration-pop">
          <PartyPopper className="size-8" />
        </span>
        <div>
          <h3 className="text-lg font-semibold tracking-tight">{t('myTasks.noTasksTitle')}</h3>
          <p className="mt-1 text-sm text-muted-foreground">{t('myTasks.noTasksDescription')}</p>
        </div>
      </div>
    </div>
  );
}
